/**
 * 个人中心-头部子组件
 * @returns
 */
import {
  Avatar,
  Box,
  Flex,
  Text,
  Image,
  Button,
  VStack,
  useBreakpointValue,
} from "@chakra-ui/react";
import userHeaderBg from "@/assets/images/user_header_bg.png";
import userHeaderMask from "@/assets/images/user_header_bg2.png";
import viplevel from "@/assets/viplevel.png";
import medal from "@/assets/medal.png";
import { useSelector, useDispatch } from "react-redux";
import { updateUser, selectUser } from "@/reducer/userslice";
import { BiSolidEdit } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

type Props = {
  // userHeaderBg: string;
  userId: string | undefined;
};
const MyHeader = (props: Props) => {
  const { userId } = props;
  const user = useSelector(selectUser);
  const avatarSize = useBreakpointValue({
    base: "sm", // 通常是'sm'或数字像24
    md: "lg", // 在lg屏幕大小及以上使用'lg'或数字像72
    lg: "xl", //
  });

  const navigate = useNavigate();

  const handleEditUsername = () => {
    navigate("/profile"); // 切换到修改个人资料页
  };

  return (
    <Box
      h="312px"
      position={"relative"}
      bg={`url('${userHeaderBg}')`}
      backgroundSize="cover"
      backgroundPosition="top center"
      bgRepeat={"no-repeat"}
    >
      <Box
        h="312px"
        overflow={"hidden"}
        bg="linear-gradient(180deg, rgba(39, 49, 77, 0) -35%, #27314D 71%)"
      >
        <Box width="80%" m="0 auto">
          <Flex
            mt="172px"
            justifyContent={"space-between"}
            alignItems="flex-end"
          >
            <Flex maxW={"60%"}>
              <Avatar
                src={`/api/v4/users/${user.id}/image`}
                // w={"110px"}
                // h={"110px"}
                size={avatarSize}
                mr="20px"
              />
              <Box flex={1} maxW="377px">
                <Flex alignItems={"center"}>
                  <Text
                    fontSize={"24px"}
                    color="#FFFFFF"
                    fontWeight="bold"
                    mr="25px"
                  >
                    {user.username || user.nickname || "安晨茜"}
                  </Text>
                  <Image mr="25px" src={viplevel} />
                  <Image mr="10px" src={medal} />
                  <Text mr="25px" fontSize={"14px"} color="#B9B9B9">
                    {user.medals || 0}
                  </Text>
                  {user.id === userId && (
                    <BiSolidEdit
                      fontSize={"18px"}
                      color="#B9B9B9"
                      cursor={"pointer"}
                      onClick={handleEditUsername}
                    />
                  )}
                  {user.id !== userId && (
                    <Button
                      borderRadius={"40px"}
                      width={"80px"}
                      height={"33px"}
                      color="#FFFFFF"
                      bgColor="#496AE1"
                      border={"none"}
                      fontSize="12px"
                      // colorScheme="#27314D"
                      _hover={{
                        color: "#FFFFFF",
                        bgColor: "#496AE1",
                      }}
                    >
                      关注TA
                    </Button>
                  )}
                </Flex>
                <Box mt="20px" fontSize={"12px"} color="#B9B9B9">
                  壬戌之秋，七月既望，苏子与客泛舟游于赤壁之下。清风徐来，水波不兴。举酒属客，诵明月之诗，歌窈窕之章。
                </Box>
              </Box>
            </Flex>
            <Flex gap="15px">
              <VStack align={"center"}>
                <Text color={"#FFFFFF"} fontSize="26px" fontFamily="Allerta">
                  {user.followers || 0}
                </Text>
                <Text color={"#B9B9B9"} fontSize="13px">
                  关注
                </Text>
              </VStack>
              <VStack align={"center"}>
                <Text color={"#FFFFFF"} fontSize="26px" fontFamily="Allerta">
                  {user.fans || 0}
                </Text>
                <Text color={"#B9B9B9"} fontSize="13px">
                  粉丝
                </Text>
              </VStack>
              <VStack align={"center"}>
                <Text color={"#FFFFFF"} fontSize="26px" fontFamily="Allerta">
                  {user.likes || 0}
                </Text>
                <Text color={"#B9B9B9"} fontSize="13px">
                  获赞
                </Text>
              </VStack>
              <VStack align={"center"}>
                <Text color={"#FFFFFF"} fontSize="26px" fontFamily="Allerta">
                  {user.publishs || 0}
                </Text>
                <Text color={"#B9B9B9"} fontSize="13px">
                  发布内容
                </Text>
              </VStack>
              <VStack align={"center"}>
                <Text color={"#FFFFFF"} fontSize="26px" fontFamily="Allerta">
                  {user.sames || 0}
                </Text>
                <Text color={"#B9B9B9"} fontSize="13px">
                  被同款数
                </Text>
              </VStack>
            </Flex>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default MyHeader;
